﻿import { IMessage } from "./models";
import { Utils } from "./utils";

export class MessageDispatcher {

    constructor(private postTo: Window | Worker, private listenOn: Window | Worker, private $q?: ng.IQService) {
        // catch messages coming from the iframe
        listenOn.addEventListener("message", event => {
            let msg: IMessage = (event as any).data;
            if (msg) {
                // if we are on the ask side, then we need to see if an answer came in
                let ask = this.asks.find(a => a.msg.id == msg.id);
                if (ask) {
                    // remove the ask
                    this.asks.remove(ask);
                    // resolve the promise
                    ask.deferred.resolve(msg.data);
                } else { // if we are on the listen side, then we're listening for a name
                    let listenMsg = { name: msg.name, id: msg.id, data: msg.data } as IMessage;
                    let listens = this.listens.filter(l => l.name == msg.name);
                    listens.forEach(l => {
                        l.handler(listenMsg);
                    });
                }
            }
        });
    }

    public asks: { msg: IMessage; deferred: ng.IDeferred<any> }[] = [];
    public listens: { name: string; handler: (msg: IMessage) => void }[] = [];

    public ask<T>(name: string, data?: any): ng.IPromise<T> {
        let deferred = this.$q.defer<T>();
        let msg: IMessage = {
            id: Utils.shortId(),
            name,
            data // data sent through postMessage cannot have functions or methods on it
        };
        this.asks.push({ msg, deferred });
        this.postMessage(msg);

        return deferred.promise;
    }

    public listen(name: string, handler: (msg: IMessage) => void) {
        this.listens.push({ name, handler });
    }

    public removeListen(name: string, handler?: (msg: IMessage) => void) {
        if (handler) { // if handler is specified, we only remove that specific listen
            this.listens.removeWhere(l => l.name == name && l.handler == handler);
        } else {
            this.listens.removeWhere(l => l.name == name);
        }
    }

    public answer(originalMsg: IMessage, data: any) {
        // post message back to other window
        let msg: IMessage = {
            id: originalMsg.id,
            name: originalMsg.name + " answer",
            data
        };
        this.postMessage(msg);
    }

    private inWorker() {
        return typeof Worker === "undefined";
    }

    private postMessage(msg: IMessage) {
        if (this.inWorker() || this.postTo instanceof Worker) {
            (this.postTo as Worker).postMessage(msg);
        } else {
            this.postTo.postMessage(msg, "*");
        }
    }
}
